module.exports = __webpack_public_path__ + "4cd26492aadd36e34a5323512569745e.woff2";